import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Department colors mapping
export const DEPARTMENT_COLORS = {
  merchandizing: {
    bg: "bg-indigo-500",
    text: "text-indigo-500",
    border: "border-l-indigo-500",
    light: "bg-indigo-50 text-indigo-700",
  },
  prepress: {
    bg: "bg-cyan-500",
    text: "text-cyan-500",
    border: "border-l-cyan-500",
    light: "bg-cyan-50 text-cyan-700",
  },
  production: {
    bg: "bg-orange-500",
    text: "text-orange-500",
    border: "border-l-orange-500",
    light: "bg-orange-50 text-orange-700",
  },
  logistics: {
    bg: "bg-slate-500",
    text: "text-slate-500",
    border: "border-l-slate-500",
    light: "bg-slate-50 text-slate-700",
  },
};

// Status colors mapping
export const STATUS_COLORS = {
  pending: {
    bg: "bg-amber-500",
    text: "text-amber-500",
    light: "bg-amber-50 text-amber-700",
  },
  in_progress: {
    bg: "bg-blue-500",
    text: "text-blue-500",
    light: "bg-blue-50 text-blue-700",
  },
  completed: {
    bg: "bg-emerald-500",
    text: "text-emerald-500",
    light: "bg-emerald-50 text-emerald-700",
  },
  delayed: {
    bg: "bg-rose-500",
    text: "text-rose-500",
    light: "bg-rose-50 text-rose-700",
  },
  returned: {
    bg: "bg-violet-500",
    text: "text-violet-500",
    light: "bg-violet-50 text-violet-700",
  },
};

// Department labels
export const DEPARTMENT_LABELS = {
  merchandizing: "Merchandizing",
  prepress: "Prepress",
  production: "Production",
  logistics: "Logistics",
  packaging: "Packaging",
};

// Status labels
export const STATUS_LABELS = {
  pending: "Pending",
  in_progress: "In Progress",
  completed: "Completed",
  delayed: "Delayed",
  returned: "Returned",
};

// Role labels
export const ROLE_LABELS = {
  admin: "Admin",
  merchant: "Merchant",
  merchandizing_hod: "Head of Merchandizing",
  prepress_hod: "Head of Prepress",
  production_hod: "Head of Production",
  logistics_hod: "Head of Logistics",
  packaging_hod: "Head of Packaging",
  prepress_manager: "Prepress Manager",
  production_manager: "Production Manager",
  logistics_manager: "Logistics Manager",
  packaging_manager: "Packaging Manager",
  team_member: "Team Member",
};

// Role options for user creation
export const ROLE_OPTIONS = [
  { value: "super_admin", label: "Super Admin" },
  { value: "admin", label: "Admin" },
  { value: "merchant", label: "Merchant" },
  { value: "merchandizing_hod", label: "Head of Merchandizing" },
  { value: "prepress_hod", label: "Head of Prepress" },
  { value: "production_hod", label: "Head of Production" },
  { value: "logistics_hod", label: "Head of Logistics" },
  { value: "packaging_hod", label: "Head of Packaging" },
  { value: "packaging_manager", label: "Packaging Manager" },
  { value: "team_member", label: "Team Member" },
];

// HoD roles
export const HOD_ROLES = [
  "merchandizing_hod",
  "prepress_hod", 
  "production_hod",
  "logistics_hod",
  "packaging_hod",
];

// Check if user is HoD
export function isHoD(role) {
  return HOD_ROLES.includes(role);
}

// Check if user can reassign tasks
export function canReassignTasks(role) {
  return role === "admin" || role === "super_admin" || HOD_ROLES.includes(role);
}

// Format date
export function formatDate(dateString) {
  if (!dateString) return "-";
  const date = new Date(dateString);
  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
}

// Format datetime
export function formatDateTime(dateString) {
  if (!dateString) return "-";
  const date = new Date(dateString);
  return date.toLocaleString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

// Check if date is overdue
export function isOverdue(dateString) {
  if (!dateString) return false;
  const date = new Date(dateString);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return date < today;
}

// Check if date is today
export function isToday(dateString) {
  if (!dateString) return false;
  const date = new Date(dateString);
  const today = new Date();
  return date.toDateString() === today.toDateString();
}

// Get days until deadline
export function getDaysUntil(dateString) {
  if (!dateString) return null;
  const date = new Date(dateString);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const diffTime = date - today;
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  return diffDays;
}

// Item types
export const ITEM_TYPES = [
  { value: "paper_bag", label: "Paper Bag" },
  { value: "napkin", label: "Napkin" },
  { value: "mailer_bag", label: "Mailer Bag" },
  { value: "label", label: "Label" },
  { value: "box", label: "Box" },
  { value: "other", label: "Other" },
];
